angular.module('dpw.components')
    .directive('dpwAffix', ['$window', '$timeout', function ($window, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var windowEl = angular.element($window);
                var elementStatus = {
                    hasWidth: element[0].style.width,
                    width: 0,
                    pristine: null,
                    current: null
                };
                var hasElementStatus;
                var timer;
                var affixed = false;
                var offsetTop = attrs.offsettop || 0;

                windowEl.on('scroll', checkPosition);
                windowEl.on('resize', function () {
                    parseElementStatus();
                    checkPosition();
                });

                parseElementStatus();

                function parseElementStatus() {
                    if (hasElementStatus) {
                        getElementStatus();
                    } else {
                        timer && $timeout.cancel(timer);
                        timer = $timeout(getElementStatus, 0);
                        timer.then(function () {
                            hasElementStatus = true;
                            checkPosition();
                        });
                    }
                }

                function getElementStatus() {
                    if (!hasElementStatus) {
                        elementStatus.pristine = element.offset();
                        elementStatus.width = element.width();
                        return;
                    }
                    elementStatus.current = element.offset();
                }

                function checkPosition () {
                    if (!hasElementStatus) {
                        return;
                    }
                    var scrollTop = windowEl.scrollTop();
                    if (scrollTop <= elementStatus.pristine.top) {
                        element.css('position', '');
                    } else {
                        if (affixed) return;
                        element.css('position', 'fixed');
                        element.css('top', parseInt(offsetTop, 10));
                        !elementStatus.hasWidth && element.css('width', elementStatus.width);
                    }
                }
            }
        };
    }]);
